// Copyright (c) Microsoft Corporation.
// Licensed under the MIT license.
export var ErrorCode;
(function (ErrorCode) {
    ErrorCode[ErrorCode["NOERROR"] = 0] = "NOERROR";
    // misc errors
    ErrorCode[ErrorCode["ERROR"] = 100] = "ERROR";
    ErrorCode[ErrorCode["PARAMETER_INVALID"] = 101] = "PARAMETER_INVALID";
    ErrorCode[ErrorCode["QR_DECODE_ERROR"] = 102] = "QR_DECODE_ERROR";
    ErrorCode[ErrorCode["SHC_DECODE_ERROR"] = 103] = "SHC_DECODE_ERROR";
    ErrorCode[ErrorCode["SHC_ENCODE_ERROR"] = 104] = "SHC_ENCODE_ERROR";
    ErrorCode[ErrorCode["SHC_FORMAT_ERROR"] = 105] = "SHC_FORMAT_ERROR";
    ErrorCode[ErrorCode["JWS_COMPACT_DECODE_ERROR"] = 106] = "JWS_COMPACT_DECODE_ERROR";
    ErrorCode[ErrorCode["JWS_COMPACT_ENCODE_ERROR"] = 107] = "JWS_COMPACT_ENCODE_ERROR";
    ErrorCode[ErrorCode["JWS_COMPACT_FORMAT_ERROR"] = 108] = "JWS_COMPACT_FORMAT_ERROR";
    ErrorCode[ErrorCode["JWS_COMPACT_MISSING"] = 109] = "JWS_COMPACT_MISSING";
    ErrorCode[ErrorCode["JWS_MISSING"] = 110] = "JWS_MISSING";
    ErrorCode[ErrorCode["JWS_MISSING_HEADER"] = 111] = "JWS_MISSING_HEADER";
    ErrorCode[ErrorCode["JWS_MISSING_PAYLOAD"] = 112] = "JWS_MISSING_PAYLOAD";
    ErrorCode[ErrorCode["JWS_MISSING_SIGNATURE"] = 113] = "JWS_MISSING_SIGNATURE";
    ErrorCode[ErrorCode["JWS_ENCODE_FAIL"] = 114] = "JWS_ENCODE_FAIL";
    ErrorCode[ErrorCode["JWS_HEADER_DECODE_FAIL"] = 115] = "JWS_HEADER_DECODE_FAIL";
    ErrorCode[ErrorCode["JWS_HEADER_ENCODE_FAIL"] = 116] = "JWS_HEADER_ENCODE_FAIL";
    ErrorCode[ErrorCode["JWS_HEADER_ERROR"] = 117] = "JWS_HEADER_ERROR";
    ErrorCode[ErrorCode["JWS_HEADER_GENERATE_FAIL"] = 118] = "JWS_HEADER_GENERATE_FAIL";
    ErrorCode[ErrorCode["JWS_SIGNATURE_DECODE_FAIL"] = 119] = "JWS_SIGNATURE_DECODE_FAIL";
    ErrorCode[ErrorCode["JWS_SIGNATURE_ENCODE_FAIL"] = 120] = "JWS_SIGNATURE_ENCODE_FAIL";
    ErrorCode[ErrorCode["JWS_SIGNATURE_MISSING"] = 121] = "JWS_SIGNATURE_MISSING";
    ErrorCode[ErrorCode["JWS_SIGNATURE_NO_PUBLIC_KEYS"] = 122] = "JWS_SIGNATURE_NO_PUBLIC_KEYS";
    ErrorCode[ErrorCode["JWS_SIGNATURE_FORMAT_ERROR"] = 123] = "JWS_SIGNATURE_FORMAT_ERROR";
    ErrorCode[ErrorCode["JWS_PAYLOAD_DECODE_ERROR"] = 124] = "JWS_PAYLOAD_DECODE_ERROR";
    ErrorCode[ErrorCode["JWS_PAYLOAD_ENCODE_ERROR"] = 125] = "JWS_PAYLOAD_ENCODE_ERROR";
    ErrorCode[ErrorCode["JWS_PAYLOAD_ERROR"] = 126] = "JWS_PAYLOAD_ERROR";
    ErrorCode[ErrorCode["JWS_PAYLOAD_ISS_MISSING"] = 127] = "JWS_PAYLOAD_ISS_MISSING";
    ErrorCode[ErrorCode["JWS_PAYLOAD_NOT_DEFLATED"] = 128] = "JWS_PAYLOAD_NOT_DEFLATED";
    ErrorCode[ErrorCode["JWS_PAYLOAD_FUTURE_NBF"] = 129] = "JWS_PAYLOAD_FUTURE_NBF";
    ErrorCode[ErrorCode["SIGNATURE_INVALID"] = 130] = "SIGNATURE_INVALID";
    ErrorCode[ErrorCode["DIRECTORY_ERROR"] = 131] = "DIRECTORY_ERROR";
    ErrorCode[ErrorCode["DIRECTORY_ISSUER_MISSING_ISS"] = 132] = "DIRECTORY_ISSUER_MISSING_ISS";
    ErrorCode[ErrorCode["DIRECTORY_ISSUER_INVALID_PROPERTY"] = 133] = "DIRECTORY_ISSUER_INVALID_PROPERTY";
    ErrorCode[ErrorCode["DIRECTORY_MISSING"] = 134] = "DIRECTORY_MISSING";
    ErrorCode[ErrorCode["DIRECTORY_ISSUER_NOT_FOUND"] = 135] = "DIRECTORY_ISSUER_NOT_FOUND";
    ErrorCode[ErrorCode["DIRECTORY_KEY_NOT_FOUND"] = 136] = "DIRECTORY_KEY_NOT_FOUND";
    ErrorCode[ErrorCode["DIRECTORY_SCHEMA_ERROR"] = 137] = "DIRECTORY_SCHEMA_ERROR";
    ErrorCode[ErrorCode["KEYS_ONLY_MATCH"] = 138] = "KEYS_ONLY_MATCH";
    ErrorCode[ErrorCode["JWK_UNEXPECTED_PROPERTY"] = 139] = "JWK_UNEXPECTED_PROPERTY";
    ErrorCode[ErrorCode["JWK_INVALID_PROPERTY"] = 140] = "JWK_INVALID_PROPERTY";
    ErrorCode[ErrorCode["JWK_INCORRECT_KID"] = 141] = "JWK_INCORRECT_KID";
    ErrorCode[ErrorCode["CRYPTO_FAILURE"] = 142] = "CRYPTO_FAILURE";
    ErrorCode[ErrorCode["DOWNLOAD_FAILED"] = 143] = "DOWNLOAD_FAILED";
    ErrorCode[ErrorCode["FHIR_VALIDATION_ERROR"] = 144] = "FHIR_VALIDATION_ERROR";
})(ErrorCode || (ErrorCode = {}));
